var render = function render(){var _vm=this,_c=_vm._self._c;return _c('activix-modal',{attrs:{"name":_vm.name},on:{"closed":_vm.onClosed,"before-open":_vm.onBeforeOpen}},[_c('template',{slot:"header"},[_c('h4',{staticClass:"modal-title"},[_vm._v(" "+_vm._s(_vm.$t('general.notes'))+" ")])]),_c('template',{slot:"body"},[(_vm.leadId)?_c('comment',{attrs:{"lead-id":_vm.leadId}}):_vm._e()],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }